<script>
  export let col = {},
    row = {},
    clickFunction,
    disabled = false,
    valueKey = "";

  let thisToggle = {};

  const onToggle = (e) => {
    if (disabled) return;
    clickFunction ? clickFunction(row, e) : "";
  };
</script>

<input
  type="checkbox"
  class="toggle toggle-secondary {disabled
    ? 'cursor-default'
    : ''} {row.isHidden ? 'hidden' : ''}"
  checked={row[valueKey]}
  on:click|preventDefault={onToggle}
  bind:this={thisToggle}
  disabled={row.isUpdating}
/>
